import { Injectable } from '@angular/core';
import { HttpMethodService } from './http-method.service';
import { Observable, Subject } from 'rxjs';
import { WebsocketService } from './websocket.service';
import { Respuesta } from '../interfaces';
// import { WebsocketService } from './websocket.service';

@Injectable({
  providedIn: 'root'
})
export class RealTimeService {
  WS_URL = '/inventario/all/';
  // public callback: Subject<Respuesta<any>>;
  constructor(private wsService: WebsocketService,
              methodService: HttpMethodService) {

    // this.callback = this.wsService.connect(methodService.baseUrlWS + this.WS_URL).map(
    //   (response: MessageEvent): any => {
    //     const data = JSON.parse(response.data);
    //     console.log(data);
    //     return data;
    //   }) as Subject<Respuesta<any>>;
  }
}
